export default "__VITE_ASSET__I_iIVy76__"